import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactGA from "react-ga";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import { Provider } from "mobx-react";
import { syncHistoryWithStore } from "mobx-react-router";
import { autorun } from "mobx";
import axios from "axios";

// Configure mobx observer batching.
// https://github.com/mobxjs/mobx-react-lite/#observer-batching
import "mobx-react-lite/batchingForReactDom";

import "antd/dist/antd.css";
import "./index.css";
import "./assets/favicon-16x16.png";
import "./assets/favicon-32x32.png";
import "./assets/favicon.png";
import "./assets/android-chrome-192x192.png";
import "./assets/android-chrome-256x256.png";
import "./assets/apple-touch-icon.png";
import "./assets/mask-icon.svg";

import Routes from "./app";
import config, { env } from "./config";
import RootStore from "app/RootStore";

console.log(
  `%cWelcome to Lawfully Intra v${config.version} [${env.toUpperCase()}]`,
  "font-size: 24px; color: #264381; padding: 2px 5px;",
);

const rootStore = new RootStore();
const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, rootStore.routerStore);

autorun(() => {
  axios.defaults.baseURL = config.baseUrl;
  axios.defaults.headers.common.Authorization = rootStore.authStore.token;
});

ReactGA.initialize(config.googleAnalytics.key);

history.subscribe((location) => {
  const page = `${location.pathname}${location.search}`;
  ReactGA.set({
    page,
    displayName: rootStore.authStore.displayName,
  });
  ReactGA.pageview(page);
});

ReactDOM.render(
  <Provider {...rootStore}>
    <Router history={history}>
      <Routes />
    </Router>
  </Provider>,
  document.getElementById("root"),
);
